import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors }: Theme) => createStyles({
  menu: {
    paddingTop: spacing(3),
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      width: '100%',
      borderTop: `2px solid ${colors.layout.divider300}`,
    },
  },
  name: {
    position: 'relative',
    width: '100%',
    textTransform: 'inherit',
    padding: spacing(2),
    borderRadius: colors.navigation.accountMenu.corner,
  },
  enabled: {
    color: colors.navigation.accountMenu.enabled.text,
    '& path': {
      fill: colors.navigation.accountMenu.enabled.icon,
    },
    '&:hover': {
      background: colors.navigation.accountMenu.hovered.fill,
      color: colors.navigation.accountMenu.hovered.name,
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        height: '100%',
        borderLeft: `2px solid ${colors.navigation.accountMenu.hovered.stroke}`,
      },
    },
    '&:focus': {
      background: colors.navigation.accountMenu.focused.fill,
      color: colors.navigation.accountMenu.focused.name,
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        height: '100%',
        borderLeft: `2px solid ${colors.navigation.accountMenu.hovered.stroke}`,
      },
    },
  },
  selected: {
    background: colors.navigation.accountMenu.selected.fill,
    color: colors.navigation.accountMenu.selected.name,
    '& path': {
      fill: colors.navigation.accountMenu.selected.icon,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      height: '100%',
      borderLeft: `2px solid ${colors.navigation.accountMenu.hovered.stroke}`,
    },
  },
  disabled: {
    cursor: 'default',
    pointerEvents: 'none',
    background: colors.navigation.accountMenu.disabled.fill,
    color: colors.navigation.accountMenu.disabled.name,
    '& path': {
      fill: colors.navigation.accountMenu.disabled.icon,
    },
  },
});

export default styles;
